import { Link } from 'react-router-dom';

import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  accountName: string;
}

export function ModernQuickAccess(props: IProps) {
  const { accountName } = props;

  const quickAccessItems = [
    {
      label: 'FAQs',
      icon: 'help',
      route: Routes.Faq,
    },
    {
      label: 'Travel Resources',
      icon: 'info',
      route: Routes.Resources,
    },
  ];

  const renderIcon = (iconType: string) => {
    switch (iconType) {
      case 'help':
        return (
          <svg
            className="modern-quick-access__icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        );
      case 'info':
        return (
          <svg
            className="modern-quick-access__icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        );
      case 'chat':
        return (
          <svg
            className="modern-quick-access__icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        );
      case 'bug':
        return (
          <svg
            className="modern-quick-access__icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <section className="modern-quick-access">
      <div className="modern-quick-access__container">
        <p className="modern-quick-access__label">QUICK ACCESS</p>
        <div className="modern-quick-access__grid">
          {quickAccessItems.map((item, index) => (
            <Link
              key={index}
              to={`/${accountName}${item.route}`}
              className="modern-quick-access__item"
            >
              <div className="modern-quick-access__item-icon">{renderIcon(item.icon)}</div>
              <p className="modern-quick-access__item-label">{item.label}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
